import formRoute from '~/pages/form/form.route';
import template from './form.html';
import controller from './form.controller';

const newRoute = {
	...formRoute,
	path: `/v5${formRoute.path}`,
	template,
	controller,
};

export default newRoute;
